import { makeSelector } from "../../../testing/index.js";
const TestingAttrs = {
  input: "data-input",
  iconLeft: "data-icon-left",
  iconRight: "data-icon-right"
};
const InputSelectors = {
  input: makeSelector("Native input element", TestingAttrs.input),
  iconLeft: makeSelector("Icon displayed on the left", TestingAttrs.iconLeft),
  iconRight: makeSelector("Icon displayed on the right", TestingAttrs.iconRight)
};
export {
  InputSelectors,
  TestingAttrs
};
